import { Component, Input, OnInit, inject } from '@angular/core';
import { MainNavigationService } from '../main-navigation.service';
import { NGXLogger } from 'ngx-logger';
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { ImageModifierPipe } from '../image-modifer.pipe';
import { teaItemProductImageProvider } from '@redirector-service/database-module';

@Component({
    selector: 'tea-shop-fe-tea-item-summary',
    templateUrl: './tea-item-summary.component.html',
    styleUrls: ['./tea-item-summary.component.css'],
    imports: [RouterLink, NgOptimizedImage],
    providers: [ImageModifierPipe]
})
export class TeaItemSummaryComponent implements OnInit {
  private mainNavigationService = inject(MainNavigationService);
  private logger = inject(NGXLogger);
  private imageModifier = inject(ImageModifierPipe);

  @Input({ required:true }) teaItem: any;
  optimizedImageUrl: string | null = null;
  imageLoading = false;

  async ngOnInit() {
    this.logger.log('TeaItemSummaryComponent ngOnInit', this.teaItem);
    
    // Check if teaItem already has image data (for direct product objects)
    if (this.teaItem?.imageURL || this.teaItem?.url) {
      const imageUrl = this.teaItem.imageURL || this.teaItem.url;
      this.imageLoading = true;
      try {
        const transformedUrl = await this.imageModifier.transform(imageUrl, { width: 800 });
        this.optimizedImageUrl = transformedUrl || null;
      } catch (error) {
        this.logger.error('Error transforming image URL', error);
        // Fallback to original URL if transformation fails
        this.optimizedImageUrl = imageUrl;
      }
      this.imageLoading = false;
      return;
    }
    
    // Only try to fetch tea item if slug exists and no direct image is available
    if (this.teaItem?.slug) {
      this.imageLoading = true;
      this.mainNavigationService.getTeaItemProduct(this.teaItem.slug).subscribe({
        next: async (teaItem) => {
          this.teaItem = teaItem;
          const teaItemProductImages = teaItem.teaItemProductImages;
          
          if (teaItemProductImages && teaItemProductImages.length > 0) {
            // Choose the teaItemProductImage with the lowest position
            const teaItemProductImage = teaItemProductImages.reduce((prev: any, current: any) => (prev.position < current.position) ? prev : current);
            this.teaItem.imageURL = teaItemProductImage.url;
            
            // Pre-transform the image URL for ngOptimizedImage
            try {
              const transformedUrl = await this.imageModifier.transform(teaItemProductImage.url, { width: 800 });
              this.optimizedImageUrl = transformedUrl || teaItemProductImage.url;
            } catch (error) {
              this.logger.error('Error transforming image URL', error);
              this.optimizedImageUrl = teaItemProductImage.url;
            }
          }
          this.imageLoading = false;
        },
        error: (error) => {
          this.logger.error('An error occurred while retrieving the tea item:', error);
          this.optimizedImageUrl = ''; // Fallback to empty string if error occurs
          this.imageLoading = false;
        },
      });
    } else {
      // No slug provided and no direct image
      this.logger.warn('No slug or image URL provided for tea item', this.teaItem);
      this.imageLoading = false;
    }
  }
}
